<template>
    <header class="headBox">
        <div class="logo">
            <img src="../assets/logo_pc.png">
            <p>{{logoText}}</p>
        </div>
        <div class="navBox">
            <div class="left">
                <a href="#ppgs">品牌故事</a>
                <a href="#czmd">查找门店</a>
                </div>
            <div class="tel">
                <a href="tel:400-6500-180"><i class="iconfont iconweibiaoti-"></i></a>
                <span>400-6500-180</span>
            </div>
        </div>
    </header>
</template>

<script>
import { getLogoWrite } from "@/utils/request";
import { getStorage } from "@/utils/tool.js";
export default {
    data() {
        return {
            isleftarrow: "left-arrow",
            showMenu: false,
            searchTag: "headSearch", // 头部search标识
            logoText: "年轻人轻奢珠宝品牌",
        };
    },
    created() {
        
    },
    mounted() {
        this.getLogo();
    },
    methods: {
        getLogo() {
            getLogoWrite().then((res) => {
                this.logoText = res.resultObject;
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.headBox {
    padding: 0.2rem;
    color: #2b2b2b;
    border-top: .033rem solid #76D3CD;
    > .logo {
        width: 100%;
        text-align: center;
        > img {
            width: 160px;
        }
        > p {
            font-size: 16px;
            color: #9fa0a0;
            padding-top: 0.1rem;
            letter-spacing: 2px;
        }
    }
    > .navBox {
        font-size: 0.11rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: -0.11rem;
        color: #5f6368;
        > .tel {
            a {
                text-decoration: none;
                color: #4b4948;
            }
            i {
                margin-right: 0.04rem;
                font-size: 0.12rem;
            }
        }
        > .left {
            font-weight: 550;
            > a {
                margin-right: 0.3rem;
                text-decoration: none;
                color: #4b4948;
                cursor: pointer;
            }
        }
    }
}
</style>
